import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";

import { Filter } from '../../models/filter.model';
import { Lookup } from '../../models/admin-models/lookup.model';

@Injectable({
    providedIn: 'root'
})
export class WorkStatusService {

    constructor(private httpClient: HttpClient) { }

    getOne(id: Number) {
        return this.httpClient.get('api/workstatuses/' + id).toPromise();
    }

    gridView() {
        return this.httpClient.get('api/workstatuses')
            .pipe(
                map((res: any) => {
                    return res;
                }),
                catchError((error) => {
                    return throwError(error);
                })
            )
    }

    createWorkStatus(lookup: Lookup) {
        return this.httpClient.post('api/workstatuses/create', lookup.data).toPromise();
    }

    editWorkStatus(lookup: Lookup) {
        return this.httpClient.post('api/workstatuses/edit', lookup.data).toPromise();
    }

    deleteWorkStatus(ids: Array<Number>) {
        return this.httpClient.post('api/workstatuses/delete', ids).toPromise();
    }

}